function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 10.4L21.6 9 16 14.6 10.4 9 9 10.4l5.6 5.6L9 21.6l1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6 5.6-5.6z",
  fill: "#FFF"
});

var SvgIconCloseWhite = function SvgIconCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyAxMC40TDIxLjYgOUwxNiAxNC42TDEwLjQgOUw5IDEwLjRMMTQuNiAxNkw5IDIxLjZMMTAuNCAyM0wxNiAxNy40TDIxLjYgMjNMMjMgMjEuNkwxNy40IDE2TDIzIDEwLjRaIiBmaWxsPSIjRkZGRkZGIi8+Cjwvc3ZnPgo=";
export { SvgIconCloseWhite as ReactComponent };